<template>
  <td>
    {{ roles }}
  </td>
</template>

<script>
export default {
  props: ["content"],
  computed: {
    roles() {
      return this.content.map(role => role.name).join(", ");
    }
  }
};
</script>

<style></style>
